export function generateFormatedURL(model: Object, isEncode? : boolean) {
  console.log(model);
  var formattedURL: string = "?";
  const entries = Object.entries(model);
  const VALUE = 1;

  entries.forEach((pair) => {
    const valueIsNotUndefinedORNullOrEmptyString =
      pair[VALUE] !== null && pair[VALUE] !== "" && pair[VALUE] !== undefined;
    // console.log(
    //   "VALUE: " +
    //     valueIsNotUndefinedORNullOrEmptyString +
    //     " , " +
    //     pair[VALUE] +
    //     " , " +
    //     pair[0]
    // );
    if (valueIsNotUndefinedORNullOrEmptyString){
      if (isEncode == true)
          pair[1] = encodeURIComponent(pair[1])
      formattedURL = formattedURL.concat(pair.join("=")).concat("&");
    }
  });
  formattedURL = formattedURL.slice(0, -1);
  console.log(formattedURL);
  return formattedURL;
}
